import loadable from '@loadable/component';
import type * as AditudeAdhesionPlacementModule from './aditudeAdhesionPlacement';
import type * as AditudeCpmstarSkinModule from './aditudeCpmstarSkin';
import type * as AditudeOutstreamModule from './aditudeOutstream';
import type * as ExCoVideoModule from './excoVideo';
import type * as VideoComponentModule from './videoComponent';

export const AditudeAdhesionPlacement = loadable(
  () => import(/* webpackChunkName: "ads-provider-aditude" */ './aditudeAdhesionPlacement'),
  {
    resolveComponent: (module: typeof AditudeAdhesionPlacementModule) => module.AditudeAdhesionPlacement,
    fallback: null
  }
);

export const AditudeCpmstarSkin = loadable(
  () => import(/* webpackChunkName: "ads-provider-aditude" */ './aditudeCpmstarSkin'),
  {
    resolveComponent: (module: typeof AditudeCpmstarSkinModule) => module.AditudeCpmstarSkin,
    fallback: null
  }
);

export const AditudeOutstream = loadable(
  () => import(/* webpackChunkName: "ads-provider-aditude" */ './aditudeOutstream'),
  {
    resolveComponent: (module: typeof AditudeOutstreamModule) => module.AditudeOutstream,
    fallback: null
  }
);

export const ExCoRichMedia = loadable(() => import('./excoVideo'), {
  resolveComponent: (module: typeof ExCoVideoModule) => module.ExCoRichMedia,
  fallback: null
});

export const VenatusRichMedia = loadable(() => import('./venatusRichMedia'), {
  fallback: null
});

export const VideoDesktopComponent = loadable(() => import('./videoComponent'), {
  resolveComponent: (module: typeof VideoComponentModule) => module.VideoDesktopComponent,
  fallback: null
});

export const VideoDockedComponent = loadable(() => import('./videoComponent'), {
  resolveComponent: (module: typeof VideoComponentModule) => module.VideoDockedComponent,
  fallback: null
});

export const VideoMobileComponent = loadable(() => import('./videoComponent'), {
  resolveComponent: (module: typeof VideoComponentModule) => module.VideoMobileComponent,
  fallback: null
});
